// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PA0Mq","title":"styles_title__liSG3","description":"styles_description__VPzb2"};